import { render, staticRenderFns } from "./CostManagement.vue?vue&type=template&id=c63b02f2&scoped=true"
import script from "./CostManagement.vue?vue&type=script&lang=js"
export * from "./CostManagement.vue?vue&type=script&lang=js"
import style0 from "./CostManagement.vue?vue&type=style&index=0&id=c63b02f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63b02f2",
  null
  
)

export default component.exports